import {
  createQuote,
  createQuoteTemplateOption,
  getFeature,
  getOwnerFromUser,
  updateQuoteTemplateOption
} from '@paintscout/util/builder'
import { CreateTemplateDialog, useClientOptions, useDialogs, useUser } from '@paintscout/ui-business'
import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import EditableQuote from 'src/components/common/EditableQuote/EditableQuote'

export default function NewQuoteTemplate() {
  const { openDialog, dismissAllDialogs } = useDialogs()
  const { options, rates, updateOptions, save: saveOptions, reset } = useClientOptions()

  const history = useHistory<{ quoteType: string }>()
  const { user, preferences } = useUser()

  const isSaved = useRef(false)
  const [template, setTemplate] = useState(null)

  useEffect(() => {
    openDialog(CreateTemplateDialog, {
      onConfirm: async (quoteTypes: string[], templateName: string) => {
        const { signature, defaultEstimatorNotes } = preferences

        const owner = getOwnerFromUser(user)

        const quoteTemplate = createQuote({
          options,
          owner,
          estimatorNotes: defaultEstimatorNotes,
          signature,
          quoteType: quoteTypes[0],
          template: null,
          rates,
          type: 'quoteTemplate'
        })

        const quoteTemplateOption = createQuoteTemplateOption({
          key: quoteTemplate._id,
          label: templateName,
          quoteTypes: [...quoteTypes],
          smartTemplate: getFeature({ options, path: 'quotes.smartTemplate' })
        })
        const updatedOptions = updateQuoteTemplateOption({ options, quoteTemplateOption })
        updateOptions({ options: updatedOptions })

        // there's a bit of a gotcha here.. we need to call dismissAllDialogs
        // because EditableQuote will mount a <DialogPortal /> before this dialog finishes dismissing
        dismissAllDialogs()
        setTemplate(quoteTemplate)
      },
      onCancel: history.goBack
    })
  }, [])

  useEffect(() => {
    // reset changed options if user leaves page
    return () => {
      // we're using saved as a ref because we want it to be up to date when we leave the page
      // but we only want this useEffect to occur once
      if (!isSaved.current) {
        // Revert to old options if no save
        updateOptions({ options })
        reset()
      }
    }
  }, [])

  if (template) {
    return (
      <EditableQuote
        quote={template}
        isNew
        disableRecovery
        onSaved={async (savedTemplate) => {
          isSaved.current = true
          setTemplate(savedTemplate)
          await saveOptions()
          history.replace(`/quotes/edit/${savedTemplate._id}`)
        }}
      />
    )
  }

  return null
}
